import { latency } from '@consumer/constants/debounce'
import { ignorePreviousCalls } from '@shared/functions'
import { useDebounceFn } from '@vueuse/core'

export function typeaheadDebounce (f: (...args: any[]) => any) {
  return ignorePreviousCalls(
    useDebounceFn(f, latency.typing),
  )
}
